<template>
    <div>
        <el-card>
            <div slot="header" class="clearfix" style="text-align:center;">
                <span style="line-height: 36px;" >分润设置</span>

            </div>
            <div class="card-body" style="text-align:left;">
                <div class="item-list">

                  <p>
                      <span class="span_1">分润（元）</span>
                      <el-input v-model="shareFee" style="width:200px;"></el-input>
                  </p>

                <p>
                      <span class="span_1">商家分润（元）</span>
                      <el-input v-model="shareFeeMerchant" style="width:200px;"></el-input>
                  </p>


                </div>


                <div style="text-align: center">
                    <el-button class="item-right" type="info" :loading="btnLogin" @click="btnSave()">保存</el-button>
                </div>
            </div>
        </el-card>
    </div>
</template>


<script>

import $ajax from '../../https/config'

export default {
  data () {
    return {
      btnLogin:false,
      shareFee:0

    }
  },
  created: function () {
    //this.pageNo = 1
    this.queryFxShare()
  },
  computed: {
    myForm: {
      set: function (value) {
        this.form = value
      },
      get: function () {
        return this.form
      }
    }
  },
  methods: {
    queryFxShare () {


      var _this = this
      $ajax.get('/fx/getFxShareFee', null, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          //var resData = []
          if (res.resultData) {
            _this.shareFee = res.resultData/100
          }
        } else {
        }
        _this.btnLogin = false
      })

      $ajax.get('/fx/getFxShareFeeMerchant', null, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          //var resData = []
          if (res.resultData) {
            _this.shareFeeMerchant = res.resultData/100
          }
        } else {
        }
        _this.btnLogin = false
      })
    },
    btnSave: function () {
      var _this = this
      _this.btnLogin = true

      var params = {
        'shareFee' : _this.shareFee*100,
        'shareFeeMerchant' : _this.shareFeeMerchant*100
      }



      $ajax.get('/fx/setFxShareFee', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          _this.$message({
            type: 'success',
            message: '保存分润信息成功!'
          })
          setTimeout(function () {
            _this.btnLogin = false
            //_this.returnBack()
            //this.$router.go(0)
          }, 1000)
        } else {
          _this.$message({
            type: 'error',
            message: '保存分润信息失败!' + res.errorMessage
          })
          _this.btnLogin = false
        }
      })
    },

  },
  components: {

  }
}
</script>

<style>
    .table_pagination {
      text-align: right;
      margin-top: 10px;
    }
    .upload-demo {

          margin-bottom:  10px;
          display: inline-block;
      }
      .span_1{
              display: inline-block;
              width: 250px;

            }
</style>



// WEBPACK FOOTER //
// src/page/fxshop/fxShareFee.vue